import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import AccountManager from '../views/AccountManager.vue'
import SeniorDesigner from '../views/SeniorDesigner.vue'
import PersonalAssistant from '../views/PersonalAssistant.vue'

// Idiomas suportados
const supportedLocales = ['en', 'pt']
const defaultLocale = 'en'

// Função para criar rotas localizadas
const createLocalizedRoutes = () => {
  const routes = []
  
  // Rotas com prefixo de idioma
  supportedLocales.forEach(locale => {
    routes.push(
      {
        path: `/${locale}`,
        name: `Home-${locale}`,
        component: Home,
        meta: { locale }
      },
      {
        path: `/${locale}/about`,
        name: `About-${locale}`,
        component: About,
        meta: { locale }
      },
      {
        path: `/${locale}/contact`,
        name: `Contact-${locale}`,
        component: Contact,
        meta: { locale }
      },
      // Work With Us oculto — rota redireciona pra home
      {
        path: `/${locale}/work-with-us`,
        redirect: `/${locale}`
      },
      {
        path: `/${locale}/account-manager`,
        name: `AccountManager-${locale}`,
        component: AccountManager,
        meta: { locale }
      },
      {
        path: `/${locale}/senior-designer`,
        name: `SeniorDesigner-${locale}`,
        component: SeniorDesigner,
        meta: { locale }
      },
      {
        path: `/${locale}/personal-assistant`,
        name: `PersonalAssistant-${locale}`,
        component: PersonalAssistant,
        meta: { locale }
      }
    )
  })
  
  return routes
}

const routes = [
  // Redirecionamento da raiz para idioma padrão
  {
    path: '/',
    redirect: `/${defaultLocale}`
  },
  
  // Redirecionamentos das rotas antigas para o idioma padrão
  {
    path: '/about',
    redirect: `/${defaultLocale}/about`
  },
  {
    path: '/contact',
    redirect: `/${defaultLocale}/contact`
  },
  {
    path: '/work-with-us',
    redirect: `/${defaultLocale}`
  },
  {
    path: '/account-manager',
    redirect: `/${defaultLocale}/account-manager`
  },
  {
    path: '/senior-designer',
    redirect: `/${defaultLocale}/senior-designer`
  },
  {
    path: '/personal-assistant',
    redirect: `/${defaultLocale}/personal-assistant`
  },
  
  // Rotas localizadas
  ...createLocalizedRoutes(),
  
  // Captura rotas não encontradas e redireciona para home padrão
  {
    path: '/:pathMatch(.*)*',
    redirect: `/${defaultLocale}`
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Middleware para configurar o idioma baseado na rota
router.beforeEach(async (to) => {
  const locale = to.meta?.locale || defaultLocale
  
  // Mapear códigos de idioma para os usados no i18n
  const i18nLocale = locale === 'en' ? 'en-US' : 'pt'
  
  // Importar i18n dinamicamente para evitar dependência circular
  const { default: i18n } = await import('../i18n')
  
  // Atualizar idioma do i18n se necessário
  if (i18n.global.locale.value !== i18nLocale) {
    i18n.global.locale.value = i18nLocale
  }
  
  // Salvar idioma no localStorage
  localStorage.setItem('user-locale', locale)
})

// Scroll para o topo sempre que a rota mudar
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router 